import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { transformFieldWithLang } from './../../utils/functions';
import './PendingBookingModal.css';

/**
 * กันไม่ให้เริ่มจองรายการใหม่ ขณะที่ยังมีรายการค้างรอชำระเงินอยู่
 *
 * ก่อนหน้านี้ลูกค้าที่กดออกจากหน้าชำระเงินยังเลือกห้องใหม่ใส่ตะกร้าและกดจองซ้ำได้
 * กลายเป็นกันห้องไว้สองใบพร้อมกันโดยตั้งใจจะจองแค่ใบเดียว -- ห้องหายจากระบบเกินจริง
 * และลูกค้าเองก็ต้องมาตามยกเลิกใบที่ไม่ได้ใช้ทีหลัง
 *
 * เลือกทางกั้นตอน "เริ่มจองใหม่" ไม่ใช่กั้นทั้งหน้า เพราะการดูห้อง ดูราคา ดูปฏิทิน
 * ไม่ได้กันห้องใคร ปิดไปก็มีแต่ทำให้ลูกค้าหาข้อมูลไม่ได้
 */
const BookingBlockedModal = ({ show, onHide, pending, hold, rooms = [], stay = null, releasing = false, onResume, onRelease }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || 'th';

  if (!pending?.id) return null;

  const secondsLeft = hold?.seconds_left;
  const clock = typeof secondsLeft === 'number' && secondsLeft > 0
    ? `${Math.floor(secondsLeft / 60)}:${String(secondsLeft % 60).padStart(2, '0')}`
    : null;

  const roomNames = (rooms || []).map((r) => transformFieldWithLang(r, 'name', lang)).filter(Boolean);
  const stayText = stay?.start_date
    ? `${moment(stay.start_date).format('DD/MM/YYYY')} – ${moment(stay.end_date).add(1, 'days').format('DD/MM/YYYY')}`
    : null;

  return (
    <Modal show={show} onHide={onHide} centered contentClassName="pbm pbb">
      <Modal.Header closeButton><Modal.Title>{t('booking_blocked_title')}</Modal.Title></Modal.Header>
      <Modal.Body>
        <p className="pbb__lead">{t('booking_blocked_body')}</p>

        <div className="pbb__card">
          {!!pending.booking_no && (
            <div className="pbb__row">
              <span>{t('booking_no')}</span>
              <b>{pending.booking_no}</b>
            </div>
          )}
          {!!roomNames.length && (
            <div className="pbb__row">
              <span>{t('room')}</span>
              <b>{roomNames.join(' · ')}</b>
            </div>
          )}
          {!!stayText && (
            <div className="pbb__row">
              <span>{t('check_in')} – {t('check_out')}</span>
              <b>{stayText}</b>
            </div>
          )}
        </div>

        {/* ประโยคเต็มประโยค ไม่ใช่หัวข้อสั้นๆ -- ยัดเป็นแถวหัวข้อ/ค่าเหมือนบรรทัดบนแล้วอ่านไม่ออก
            ว่าเลขเวลาไปคู่กับอะไร จึงให้ไหลเป็นประโยคเดียวโดยมีนาฬิกาอยู่ท้ายประโยค */}
        {!!clock && (
          <p className="pbb__timer">
            {t('pending_payment_hint')} <b className="pbb__clock">{clock}</b>
          </p>
        )}
      </Modal.Body>
      <Modal.Footer className="pbb__footer">
        <Button variant="outline-secondary" onClick={onHide} disabled={releasing}>{t('close')}</Button>
        {!!onRelease && (
          <Button variant="outline-danger" onClick={onRelease} disabled={releasing}>
            {releasing ? t('please_wait') : t('pending_payment_cancel_pick_new')}
          </Button>
        )}
        {!!onResume && (
          <Button variant="dark" onClick={onResume} disabled={releasing}>{t('pending_payment_resume')}</Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default BookingBlockedModal;
